export default __webpack_public_path__ + "media/images/lp/About-sp-ad0a6ce6b60f00676a2e02f9202bd160.jpg";